/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WaterLevelProfile
 */
export interface WaterLevelProfile {
  /**
   *
   */
  url: string;
}

/**
 * Check if a given object implements the WaterLevelProfile interface.
 */
export function instanceOfWaterLevelProfile(value: object): value is WaterLevelProfile {
  if (!("url" in value) || value["url"] === undefined) return false;
  return true;
}

export function WaterLevelProfileFromJSON(json: any): WaterLevelProfile {
  return WaterLevelProfileFromJSONTyped(json, false);
}

export function WaterLevelProfileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WaterLevelProfile {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"],
  };
}

export function WaterLevelProfileToJSON(json: any): WaterLevelProfile {
  return WaterLevelProfileToJSONTyped(json, false);
}

export function WaterLevelProfileToJSONTyped(
  value?: WaterLevelProfile | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    url: value["url"],
  };
}
